export const DIFFERENTIAL_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png",
    "contentUrl": "https://everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/diferencial#webpage",
   "url": "https://everest.ind.br/pt/diferencial",
   "name": "Nosso Diferencial | Por Que Escolher a Everest",
   "description": "Conheça os diferenciais Everest: obsessão por qualidade, reservatórios em plástico de engenharia, durabilidade e tecnologia superior.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/diferencial#breadcrumb"
   },
   "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/diferencial.jpg"
   }
  },
  {
   "@type": "AboutPage",
   "@id": "https://everest.ind.br/pt/diferencial#aboutpage",
   "url": "https://everest.ind.br/pt/diferencial",
   "name": "Nosso Diferencial | Por Que Escolher a Everest",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/diferencial#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Diferencial",
     "item": "https://everest.ind.br/pt/diferencial"
    }
   ]
  }
 ]
}
